import { BUTTON } from "../sim";
import { outlinedText } from "./hud";

export interface InputView {
  readonly label: string;
  readonly bits: number;
}

const CHIPS: readonly (readonly [string, number])[] = [
  ["←", BUTTON.left],
  ["→", BUTTON.right],
  ["↑", BUTTON.up],
  ["↓", BUTTON.down],
  ["□", BUTTON.lightPunch],
  ["△", BUTTON.heavyPunch],
  ["✕", BUTTON.lightKick],
  ["○", BUTTON.heavyKick],
  ["блок R2", BUTTON.block],
  ["L2", BUTTON.super],
];

/**
 * Индикатор нажатий: какие кнопки игра видит у каждого игрока прямо сейчас и последняя клавиша, дошедшая до
 * страницы. Нужен в тренировке и для поиска «кнопки не работают».
 */
export function drawInputIndicator(
  context: CanvasRenderingContext2D,
  players: readonly InputView[],
  lastKey: string,
  pads: readonly string[],
): void {
  const top = 160;
  players.forEach((player, side) => {
    const y = top + side * 56;
    outlinedText(context, player.label, 24, y, 22, "#e8e2f0", "left", "normal");
    CHIPS.forEach(([name, mask], index) => {
      const x = 24 + index * 44;
      const on = (player.bits & mask) !== 0;
      context.fillStyle = on ? "#ffd24a" : "rgba(40, 30, 44, 0.85)";
      context.fillRect(x, y + 26, 40, 26);
      context.fillStyle = on ? "#1a0c08" : "#8a7e96";
      context.font = 'bold 18px "DejaVu Sans", Arial, sans-serif';
      context.textAlign = "center";
      context.textBaseline = "middle";
      context.fillText(name, x + 20, y + 40);
    });
  });
  outlinedText(
    context,
    `клавиша: ${lastKey || "ещё ни одной"}`,
    24,
    top + players.length * 56 + 6,
    20,
    "#b8b0c8",
    "left",
    "normal",
  );
  outlinedText(
    context,
    `геймпады: ${pads.length ? pads.join(" · ") : "нет"}`,
    24,
    top + players.length * 56 + 32,
    18,
    "#8a7e96",
    "left",
    "normal",
  );
}
